<template>
	<div style="overflow-x: hidden;">
		<el-row :gutter="20">
			<el-col :span="12">
				<el-card shadow="hover" style="height:445px;">
					<div class="user-info">
						<img :src="headImage" class="user-avator" alt="">
						<div class="user-info-cont">
							<div class="user-info-name">{{loginInfo.name}}</div>
							<div>{{loginInfo.rolename}}</div>
						</div>
					</div>
					<div class="user-info-list"><span>本次登录时间：</span>{{loginInfo.nowtime}}</div>
					<div class="user-info-list"><span>本次登录IP：</span>{{loginInfo.nowip}}</div>
					<div class="user-info-list"><span>上次登录时间：</span>{{loginInfo.lasttime}}</div>
					<div class="user-info-list"><span>上次登录IP：</span>{{loginInfo.lastip}}</div>
				</el-card>
			</el-col>
			<el-col :span="12">
				<el-row :gutter="20" class="mgb20">
					<el-col :span="8">
						<el-card shadow="hover" :body-style="{padding: '0px'}">
							<div class="grid-content grid-con-1">
								<i class="icon_lxb-visit grid-con-icon"></i>
								<div class="grid-cont-right">
									<div class="grid-num">{{ statistics.VisitNum }}</div>
									<div>今日访问量</div>
								</div>
							</div>
						</el-card>
					</el-col>
					<el-col :span="8">
						<el-card shadow="hover" :body-style="{padding: '0px'}">
							<div class="grid-content grid-con-3">
								<i class="el-icon-edit grid-con-icon"></i>
								<div class="grid-cont-right">
									<div class="grid-num">{{ statistics.OptNum }}</div>
									<div>今日操作</div>
								</div>
							</div>
						</el-card>
					</el-col>
					<el-col :span="8">
						<el-card shadow="hover" :body-style="{padding: '0px'}">
							<div class="grid-content grid-con-2">
								<i class="icon_lxb-card grid-con-icon"></i>
								<div class="grid-cont-right">
									<div class="grid-num">{{ statistics.OpenCardNum }}</div>
									<div>本月发卡</div>
								</div>
							</div>
						</el-card>
					</el-col>
				</el-row>
				<!--<el-card shadow="hover" style="height:300px;">
					<div slot="header" class="clearfix">
						<span>系统公告</span>
						<el-button style="float: right; padding: 3px 0" type="text">添加</el-button>
					</div>
					<el-table :data="todoList" :show-header="false" height="304" style="width: 100%;font-size:14px;">
						<el-table-column width="40">
							<template slot-scope="scope">
								<el-checkbox v-model="scope.row.status"></el-checkbox>
							</template>
						</el-table-column>
						<el-table-column>
							<template slot-scope="scope">
								<div class="todo-item" :class="{'todo-item-del': scope.row.status}">{{scope.row.title}}</div>
							</template>
						</el-table-column>
						<el-table-column width="100">
							<template slot-scope="scope">
								<el-button type="primary" icon="el-icon-edit" circle></el-button>
								<el-button type="danger" icon="el-icon-delete" circle></el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-card>-->
				<el-card shadow="hover">
					<schart ref="cards" class="schart" canvasId="cards" :data="visitData" type="line" :options="options0"></schart>
				</el-card>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :span="12">
				<el-card shadow="hover">
					<schart ref="visits" class="schart" canvasId="visits" :data="optData" type="line" :options="options1"></schart>
				</el-card>
			</el-col>
			<el-col :span="12">
				<el-card shadow="hover">
					<schart ref="opts" class="schart" canvasId="opts" :data="openCardData" type="line" :options="options2"></schart>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
    import Schart from 'vue-schart';
    import bus from '../common/bus';
    export default {
        name: 'home',
        data() {
            return {
                loginInfo: window.$gloable.userinfo.obj,
                headImage: window.$gloable.userinfo.obj.headimage,
				statistics: {
					VisitNum: 0,
					OptNum: 0,
					OpenCardNum: 0,
				},
				visitData: [],
				optData: [],
				openCardData: [],
                options0: {
                    title: '最近七天用户访问趋势',
                    fillColor: '#FC6FA1',
                    axisColor: '#008ACD',
                    contentColor: '#EEEEEE',
                    bgColor: '#F5F8FD',
                    bottomPadding: 30,
                    topPadding: 30
                },
                options1: {
                    title: '最近七天用户操作趋势',
                    fillColor: '#FC6FA1',
                    axisColor: '#008ACD',
                    contentColor: '#EEEEEE',
                    bgColor: '#F5F8FD',
                    bottomPadding: 30,
                    topPadding: 30
                },
                options2: {
                    title: '最近一年发卡趋势',
                    fillColor: '#FC6FA1',
                    axisColor: '#008ACD',
                    contentColor: '#EEEEEE',
                    bgColor: '#F5F8FD',
                    bottomPadding: 30,
                    topPadding: 30
                }
            }
        },
        components: { Schart },
        computed: {
        },
        created() {
            this.handleListener();
            //this.changeDate();
			this.loadStatistics();
        },
        activated() {
            this.handleListener();
        },
        deactivated() {
            window.removeEventListener('resize', this.renderChart);
            bus.$off('collapse', this.handleBus);
        },
        methods: {
            /*changeDate() {
                const now = new Date().getTime();
                this.data.forEach((item, index) => {
                    const date = new Date(now - (6 - index) * 86400000);
                    item.name = `${date.getFullYear()}/${date.getMonth()+1}/${date.getDate()}`
                })
            },*/
            handleListener() {
                bus.$on('collapse', this.handleBus);
                // 调用renderChart方法对图表进行重新渲染
                window.addEventListener('resize', this.renderChart);
            },
            handleBus(msg) {
                setTimeout(() => {
                    this.renderChart()
                }, 300);
            },
            renderChart() {
                this.$refs.visits.renderChart();
                this.$refs.opts.renderChart();
                this.$refs.cards.renderChart();
            },
			loadStatistics() {
				window.ax.get('api/home/statistics?sign=' + window.$gloable.userinfo.sign, { }).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						data = data.data;
						this.statistics.VisitNum = data.today.visitNum;
						this.statistics.OptNum = data.today.optNum;
						this.statistics.OpenCardNum = data.today.openCardNum;
						this.visitData = data.chart.visit;
						this.optData = data.chart.opt;
						this.openCardData = data.chart.openCard;
					} else {
						this.$message.error(data.message);
					}
				}).catch(err => {
					this.$message.error('执行脚本出错，请联系管理员');
				});
			}
        }
    }
</script>


<style scoped>
    .el-row {
        margin-bottom: 20px;
    }

    .grid-content {
        display: flex;
        align-items: center;
        height: 80px;
    }

    .grid-cont-right {
        flex: 1;
        text-align: center;
        font-size: 14px;
        color: #999;
    }

    .grid-num {
        font-size: 30px;
        font-weight: bold;
        color: rgb(45, 140, 240);
    }

    .grid-con-icon {
        font-size: 50px;
        width: 80px;
        height: 80px;
        text-align: center;
        line-height: 80px;
        color: #fff;
        /*background: rgb(45, 140, 240);*/
    }

    .grid-con-1 .grid-con-icon {
        background: rgb(45, 140, 240);
    }

    .grid-con-2 .grid-con-icon {
        background: rgb(100, 213, 114);
    }

    .grid-con-3 .grid-con-icon {
        background: rgb(242, 94, 67);
    }
    .user-info {
        display: flex;
        align-items: center;
        padding-bottom: 30px;
        border-bottom: 5px double #ccc;
        margin-bottom: 30px;
    }

    .user-avator {
        width: 180px;
        height: 180px;
        border-radius: 50%;
		margin-left: 50px;;
    }

    .user-info-cont {
        padding-left: 50px;
        flex: 1;
        font-size: 14px;
        color: #999;
    }

    .user-info-cont div:first-child {
        font-size: 30px;
        color: #222;
    }

    .user-info-list {
        font-size: 16px;
        color: #999;
        line-height: 25px;
        border-bottom: 3px dashed #EEEEEE;
        margin: 15px 60px;
    }

    .user-info-list span {
        display: inline-block;
        width: 180px;
        padding-right: 5px;
        text-align: right;
    }

    .mgb20 {
        margin-bottom: 20px;
    }

    .todo-item {
        font-size: 14px;
    }

    .todo-item-del {
        text-decoration: line-through;
        color: #999;
    }

    .schart {
        width: 100%;
        height: 300px;
    }
</style>
